__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "mylinkpayments.frontend";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "2.12.0", () => (__webpack_require__.e(879).then(() => (() => (__webpack_require__(49879))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(701), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(2701))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(71468))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(267), __webpack_require__.e(118), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(820)]).then(() => (() => (__webpack_require__(70118))))));
			register("react-router", "7.18.2", () => (Promise.all([__webpack_require__.e(267), __webpack_require__.e(283), __webpack_require__.e(949)]).then(() => (() => (__webpack_require__(29949))))));
			register("react", "18.3.1", () => (__webpack_require__.e(384).then(() => (() => (__webpack_require__(55384))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};